// src/pages/TermsOfService.js
import React from 'react';

const TermsOfService = () => {
  return (
    <section className="container mx-auto px-4 py-20">
      <h1 className="text-3xl font-bold text-[#12332A] mb-6">Terms of Service</h1>
      <div className="text-gray-700">
        <p className="mb-6">Last updated: January 2025</p>

        <p className="mb-6">
          These Terms of Service ("Terms") govern your access to and use of the services provided by PerspectiveHQ. By accessing or using our website and services, you agree to comply with these Terms.
        </p>

        <h2 className="text-2xl font-bold text-[#12332A] mb-4">1. Accepting the Terms</h2>
        <p className="mb-4">
          By using our services, you agree to be bound by these Terms. If you do not agree, you may not use our services.
        </p>

        <h2 className="text-2xl font-bold text-[#12332A] mb-4">2. Use of Our Services</h2>
        <p className="mb-4">
          You agree to use our services only for lawful purposes and in accordance with these Terms. You must not use our services in any way that violates applicable laws or regulations.
        </p>

        <h2 className="text-2xl font-bold text-[#12332A] mb-4">3. User Responsibilities</h2>
        <p className="mb-4">
          You are responsible for maintaining the confidentiality of your account and any activities under your account. You agree to immediately notify us of any unauthorized use of your account.
        </p>

        <h2 className="text-2xl font-bold text-[#12332A] mb-4">4. Intellectual Property</h2>
        <p className="mb-4">
          All content on our website and services, including text, graphics, logos, and images, is owned by PerspectiveHQ and is protected by intellectual property laws.
        </p>

        <h2 className="text-2xl font-bold text-[#12332A] mb-4">5. Limitation of Liability</h2>
        <p className="mb-4">
          To the fullest extent permitted by law, PerspectiveHQ shall not be liable for any damages arising out of or in connection with your use of our services.
        </p>

        <h2 className="text-2xl font-bold text-[#12332A] mb-4">6. Termination</h2>
        <p className="mb-4">
          We may suspend or terminate your access to our services at any time, with or without notice, if you violate these Terms.
        </p>

        <h2 className="text-2xl font-bold text-[#12332A] mb-4">7. Changes to the Terms</h2>
        <p className="mb-4">
          We may update these Terms at any time. Any changes will be posted on this page with an updated revision date. Please review these Terms periodically.
        </p>

        <h2 className="text-2xl font-bold text-[#12332A] mb-4">8. Contact Us</h2>
        <p className="mb-4">
          If you have any questions or concerns about these Terms, please contact us at:
        </p>
        <p className="mb-4">Email: info@perspectivehq.co.za</p>
      </div>
    </section>
  );
};

export default TermsOfService;
